export { Bu };
/**
 * при автоматических счетах (AM, н-р 5300, 5400, 4300, 4400) BU не заполняется.
 * BU-ключ используется только при мануальном выборе НДС.
 */
var Bu;
(function (Bu) {
    /**
     * Keine USt
     * @type {number}
     */
    Bu[Bu["KU"] = 0] = "KU";
    /**
     * bu 0%
     * @type {number}
     */
    Bu[Bu["BU1"] = 1] = "BU1";
    /**
     * USt
     * Доходные счета (н-р: 4300, 4400) SKR4 примеры
     * 7% = BU 2 = # 3801 (USt) haben
     * 19% = BU 3 = # 3806 (USt) haben
     * @type {number}
     */
    Bu[Bu["BU2"] = 2] = "BU2";
    Bu[Bu["BU3"] = 3] = "BU3";
    /**
     * VSt
     * Расходные счета (н-р: 5300, 5400) SKR4 примеры
     * 7% = BU 8 = # 1401 (VSt) soll
     * 19% = BU 9 = # 1406 (VSt) soll
     */
    Bu[Bu["BU8"] = 8] = "BU8";
    Bu[Bu["BU9"] = 9] = "BU9";
    Bu[Bu["BU46"] = 46] = "BU46";
    /**
     * Reverse Charge: SKR4 примеры
     * 19/19% (EU-Erwerb) = BU 19 = # 1404 (VSt) soll + # 3804 (USt) haben
     * 19/19% (§ 13b UStG) = BU 94 = # 1407 (VSt) soll + # 3837 (USt) haben
     * НДС насчитывается сверху суммы!!! 1000,00 ЕUR выставили в счет (без НДС). Программа насчитывает сверху 19%, т.к. 190,00 ЕUR.
     */
    Bu[Bu["BU18"] = 18] = "BU18";
    Bu[Bu["BU19"] = 19] = "BU19";
    Bu[Bu["BU91"] = 91] = "BU91";
    Bu[Bu["BU94"] = 94] = "BU94";
    Bu[Bu["BU92"] = 92] = "BU92";
    Bu[Bu["BU95"] = 95] = "BU95";
    Bu[Bu["BU120"] = 120] = "BU120";
})(Bu || (Bu = {}));
export { BuScope };
var BuScope;
(function (BuScope) {
    BuScope["M"] = "M";
    BuScope["V"] = "V";
})(BuScope || (BuScope = {}));
export class BuScopes {
    static ScopeM = new Set([BuScope.M]);
    static ScopeV = new Set([BuScope.V]);
    static ScopeAll = new Set([BuScope.M, BuScope.V]);
    static ScopeNone = new Set();
}
/**
 * § 13b обязателен, если Bu = 91, 92, 94 или 95 (USt13b)
 */
export const USt13bOptionsM = [7, 1, 2, 3, 4, 5, 13, 8, 9, 10, 11, 12, 16, 18];
export const USt13bOptionsV = [101, 102];
export { USt13bM };
var USt13bM;
(function (USt13bM) {
    USt13bM[USt13bM["Other"] = 7] = "Other";
    USt13bM[USt13bM["N1"] = 1] = "N1";
    USt13bM[USt13bM["N2"] = 2] = "N2";
    USt13bM[USt13bM["N3"] = 3] = "N3";
    USt13bM[USt13bM["N4"] = 4] = "N4";
    USt13bM[USt13bM["N5a"] = 5] = "N5a";
    USt13bM[USt13bM["N5b"] = 13] = "N5b";
    USt13bM[USt13bM["N6"] = 8] = "N6";
    USt13bM[USt13bM["N7"] = 9] = "N7";
    USt13bM[USt13bM["N8"] = 10] = "N8";
    USt13bM[USt13bM["N9"] = 11] = "N9";
    USt13bM[USt13bM["N10"] = 12] = "N10";
    USt13bM[USt13bM["N11"] = 16] = "N11";
    USt13bM[USt13bM["N12"] = 18] = "N12";
})(USt13bM || (USt13bM = {}));
export { USt13bV };
/**
 * § 13b обязателен, если Bu = 46 (Ust13b2)
 */
var USt13bV;
(function (USt13bV) {
    USt13bV[USt13bV["N101"] = 101] = "N101";
    USt13bV[USt13bV["N102"] = 102] = "N102";
})(USt13bV || (USt13bV = {}));
export const USt13bTitles = Object.freeze({
    [USt13bM.Other]: "Im Inland steuerpflichtige sonstige Leistungen eines im übrigen Gemeinschaftsgebiet ansässigen Unternehmers",
    [USt13bM.N1]: "Nr. 1. Bezogene Leistungen eines im Ausland ansässigen Unternehmers",
    [USt13bM.N2]: "Nr. 2. Lieferungen sicherungsübereigneter Gegenstände durch den Sicherungsgeber an den Sicherungsnehmer außerhalb des Insolvenzverfahrens",
    [USt13bM.N3]: "Nr. 3. Umsätze, die unter das Grunderwerbsteuergesetz fallen",
    [USt13bM.N4]: "Nr. 4. Bauleistungen eines im Inland ansässigen Unternehmers",
    [USt13bM.N5a]: "Nr. 5a. Lieferung von Gas und Elektrizität von im Ausland ansässigem Unternehmer",
    [USt13bM.N5b]: "Nr. 5b. Lieferung von Gas und Elektrizität von im Inland ansässigem Unternehmer",
    [USt13bM.N6]: "Nr. 6. Treibhausgasemissionszertifikate",
    [USt13bM.N7]: "Nr. 7. Lieferung von Altmetall, Schrott, Plastikabfälle o.Ä. (Anlage 3)",
    [USt13bM.N8]: "Nr. 8. Reinigen von Gebäuden und Gebäudeteilen",
    [USt13bM.N9]: "Nr. 9. Lieferung von Gold",
    [USt13bM.N10]: "Nr. 10. Lieferung von Mobilfunkgeräten, Tablet-Computern und Spielekonsolen sowie von integrierten Schaltkreisen",
    [USt13bM.N11]: "Nr. 11. Lieferung der in der Anlage 4 bezeichneten Gegenstände (z.B. Edelmetalle, unedle Metalle)",
    [USt13bM.N12]: "Nr. 12. Sonstige Leistungen auf dem Gebiet der Telekommunikation",
    [USt13bV.N101]: "Übrige steuerpflichtige Umsätze nach § 13b Abs. 1 und 2 UStG",
    [USt13bV.N102]: "Lieferung von Mobilfunkgeräten, Tablet-Computern und Spielekonsolen sowie von integrierten Schaltkreisen nach § 13b Abs. 2 Nr. 10 UStG",
});
const commonRoute = Object.freeze({
    bmg: 84,
    ust: 85,
    vst: 67,
});
export const USt13bVatRouting = Object.freeze({
    [USt13bM.Other]: { bmg: 46, ust: 47, vst: 67 },
    [USt13bM.N1]: { bmg: 84, ust: 85, vst: 67 },
    [USt13bM.N2]: { bmg: 84, ust: 85, vst: 67 },
    [USt13bM.N3]: { bmg: 73, ust: 74, vst: 67 },
    [USt13bM.N4]: commonRoute,
    [USt13bM.N5a]: commonRoute,
    [USt13bM.N5b]: commonRoute,
    [USt13bM.N6]: commonRoute,
    [USt13bM.N7]: commonRoute,
    [USt13bM.N8]: commonRoute,
    [USt13bM.N9]: commonRoute,
    [USt13bM.N10]: commonRoute,
    [USt13bM.N11]: commonRoute,
    [USt13bM.N12]: commonRoute,
    [USt13bV.N101]: { bmg: 60 },
    [USt13bV.N102]: { bmg: 60 },
});
export const getUst13bData = (value) => {
    if ([Bu.BU91, Bu.BU92, Bu.BU94, Bu.BU95].includes(value)) {
        return {
            options: USt13bOptionsM.map(value => ({
                value,
                title: USt13bTitles[value],
                vatRouting: USt13bVatRouting[value],
            })),
            scope: BuScope.M,
            hint: "Sachverhalte gem. § 13b (1) und (2) Nr. 1-12 UStG beim Leistungsempfänger",
        };
    }
    if (value === Bu.BU46) {
        return {
            options: USt13bOptionsV.map(value => ({
                value,
                title: USt13bTitles[value],
                vatRouting: USt13bVatRouting[value],
            })),
            scope: BuScope.V,
            hint: "Steuerpflichtige Umsätze, für die der Leistungsempfänger die Steuer nach § 13b (5) UStG schuldet",
        };
    }
    return { options: undefined, scope: undefined, hint: undefined };
};
//# sourceMappingURL=Bu.js.map